import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Header = () => {
  const { company, navItems } = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur shadow-[0_1px_20px_rgba(0,0,0,0.06)] py-3" : "bg-white py-5"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 flex items-center justify-between">
        <Link to="/" className="flex flex-col leading-none">
          <span className="font-logo text-[#23211e] text-[19px] md:text-[22px] tracking-[0.16em] leading-[1.15]">
            FLETCHER &amp; STONE
          </span>
          <span className="font-body text-[#94664f] text-[9px] md:text-[10px] tracking-[0.42em] uppercase mt-1">
            Building Contractors
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={`tel:${company.phone.replace(/\s/g, "")}`}
            className="flex items-center gap-2 text-[#23211e] border border-[#e2ddd4] px-4 py-2 hover:border-[#94664f] hover:text-[#94664f] transition-colors"
          >
            <Phone size={14} strokeWidth={1.5} />
            <span className="font-body text-[12px] tracking-[0.08em]">{company.phone}</span>
          </a>
        </nav>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-[#23211e] p-1"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} strokeWidth={1.2} /> : <Menu size={26} strokeWidth={1.2} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-white ${
          open ? "max-h-[520px] border-t border-[#eee9e0]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`py-3.5 border-b border-[#f2eee6] nav-link ${
                location.pathname === item.path ? "active" : ""
              }`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={`tel:${company.phone.replace(/\s/g, "")}`}
            className="flex items-center gap-2 text-[#94664f] py-4"
          >
            <Phone size={15} strokeWidth={1.5} />
            <span className="font-body text-[13px] tracking-[0.08em]">{company.phone}</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
